import { Typography } from '@mui/material';
import * as React from 'react';

export const RoleAssignmentsPage: React.FunctionComponent = () => {
    return <Typography>RoleAssignments page: Work in progress</Typography>;
};
